<template>
  <v-footer padless>
    <footer>
        <div class="footer">
          <v-container>
            <v-row class="">
                <v-col xs="12" sm="12" md="3" lg="3" class="responsive-pad">
                    <div class="infos">
                        <v-img
                          eager
                          src="@/assets/red_typo.png"
                          max-width="145"
                          max-height="30"
                          alt="sportopia logo"
                        ></v-img>
                                            <p class="contact-info">
                          <span>sportopia2019@gmail.com</span><br>
                          <span>Tel: +216 20 188 556</span>
                        </p>
                    </div>
                </v-col>
                
                <v-col xs="12" sm="12" md="6" lg="6" class="responsive-pad">
                    <div class="links">
                      <ul
                        v-for="link in links"
                        :key="link.text"
                      >
                        <li>
                          <router-link :href="link.to" :to="link.to" :title="link.text">{{ link.text }}</router-link>
                        </li>
                      </ul>
                    </div>
                </v-col>

                <v-col xs="12" sm="12" md="3" lg="3" class="responsive-pad">
                    <div class="follow">
                      <ul>
                        <li>
                          <a href="https://www.facebook.com/sportopiaApp/" target="_Blank" title="Sportopia facebook">
                            <v-icon color="#3b5998" size="35">mdi-facebook</v-icon>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/sportopia_app" target="_Blank" title="Sportopia instagram">
                            <v-icon color="#3f729b" size="35">mdi-instagram</v-icon>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/company/sportopia-app" target="_Blank" title="Sportopia linkedin">
                            <v-icon color="#0e76a8" size="35">mdi-linkedin</v-icon>
                          </a>
                        </li>
                      </ul>
                      <p class="copright">made with love by Sportopia © 2020</p>
                    </div>
                </v-col>

            </v-row>

          </v-container>
        </div>
    </footer>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { text: "Home", to: "/" },
      { text: "Conditions générales", to: "/cgu" },
      { text: "Politique de confidentialité", to: "/privacy" },
      { text: "Contact Us", to: "contact" }
    ]
  })
};
</script>

<style scoped>
footer{
  background: #f5f5f5;
  width: 100%;
}
.footer{
  background: #E8E8E8;
}
.col{
  align-self: center;
  padding: 0px 12px;
}
.infos{
  padding: 0 50px 0 0px;
}
.infos .v-image{
  margin-bottom: 0px;
}
.infos p{
  font-size: 17px;
}
.links{
  display: inline-flex;
}
.links p{
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
}
.links ul{
  list-style: none;
  padding-left: 25px;
}
.links ul:first-child{
  padding-left: 0;
}
.links ul a{
    color: #000;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    display: block;
}
.follow{
  text-align: right;
}
.follow span{
  display: block;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
}
.follow p{
  font-size: 14px;
  padding: 0 10px;
}
.follow ul{
    list-style: none;
    display: inline-flex;
    -ms-flex-pack: justify;
    text-align: right;
}
.follow ul li{
  padding-right: 15px;
}
.follow ul li:last-child{
  padding-right: 0;
}
.follow ul a{
  color: initial;
  text-decoration: none;
}
.copright{
      text-align: right;
    /* margin-bottom: 10px; */
    color: rgba(0, 0, 0, 0.87);
    text-decoration: none;
    font-size: 14px;
    margin-bottom: 0px !important;
    display: block;
}
@media (max-width: 786px){
  .footer{
    background: #E8E8E8;
    padding: 30px 30px 15px 30px;
  }
  .copright-parent{
    text-align: center;
    float: none;
    margin: 0px;
  }
  .copright{
    color: #000;
    text-align: center;
    font-weight: 500;
    padding-top: 20px;
    margin: auto;
    display: block;
  }
  .infos {
    padding: 0;
  }
  .infos .v-image{
    display: block;
    margin: auto;
    margin-bottom: 10px;
  }
  .infos p, .links ul a{
    font-size: 10px;
  }
  .follow{
    text-align: center;
  }
  .follow ul{
    margin: 10px 0;
  }
}
</style>
